<template>
	<div class="page">
		<div id="academy" :style="{ backgroundImage: 'url(' + backgroundImage + ')' }" @touchstart="touchstart($event)"
			@touchmove.prevent="touchmove($event)" @touchend.prevent="touchend($event)"
			@mousedown.prevent="mousedown($event)" @mouseup.prevent="mouseup($event)"
			@mousemove.prevent="mousemove($event)"></div>
		<!-- <canvas id="canvas2d"></canvas> -->

		<div class="menu-view left-menu-view" :class="{ fullScreen: fullScreen }">
			<!-- <div class="menu-ces">
				<div class="search-view">
					<input v-model="search" type="text" />
					<van-icon name="search" />
				</div>
				<div class="data-view">
					<template v-for="(item, index) in showModeDetails">
						<div class="data-item" :class="{ detailAction: dataCurrent == item.index }"
							@click="clickModeDetail(item.index)">
							{{ item.detailsName }}
						</div>
					</template>
				</div>
			</div> -->
			<div style="position: absolute">
				<div class="menu-item" @click="reset">
					<i class="iconfont icon-shuaxin"></i>
					<span>重置</span>
				</div>
				<!-- <div class="menu-item" :class="{ action: showCfslider }" @click="clickShowCfslider">
					<i class="iconfont icon-tubiao"></i>
					<span>拆分</span>
				</div> -->
				<div class="menu-item" @click="showimage">
					<!-- <i class="iconfont icon-tupian" ></i> -->
					<img class="icon" src="@/assets/icon/icon-photo.png" />
					<span>图片</span>
				</div>
			</div>
		</div>

		<div class="menu-view right-menu-view" :class="{ fullScreen: fullScreen }">
			<div class="menu-item" @click="showSet">
				<i class="iconfont icon-shezhi"></i>
				<span>设置</span>
			</div>
			<div class="menu-item share-menu" @click.stop="showShare = true">
				<i class="iconfont icon-JC_054"></i>
				<span>分享</span>
			</div>
			<div class="menu-item" :class="{ action: modelData && modelData.collectionState == '1' }"
				@click="clickCollection">
				<i class="iconfont icon-shoucang"></i>
				<span>收藏</span>
			</div>
			<div class="menu-item" @click="fullScreen = true">
				<i class="iconfont icon-24gf-fullScreenEnter"></i>
				<span>全屏</span>
			</div>
			<!-- <div class="menu-item" @click="init2d">
         <i class="iconfont icon-huabi" ></i>
        <span>画笔</span>
      </div> -->
			<!-- <div class="menu-item" :class="{ action: is_showAll }" @click="showOrhidden">
				<i class="iconfont icon-fenzu"></i>
				<span v-if="is_showAll">隐藏</span>
				<span v-else>全显</span>
			</div> -->
			<!-- <div class="menu-item" @click="render">
        <img class="icon" src="@/assets/icon/icon-ref.png" />
        <span style="font-size:0.2rem;transform: scale(0.8);">自动旋转</span>
      </div> -->
			<div class="menu-item" :class="{ action: istouch }" @click="istouch = !istouch">
				<i class="iconfont icon-pingyi"></i>
				<span>平移</span>
			</div>
			<div class="menu-item" :class="{ action: rotateTime }" @click="renderOrStop">
				<i class="iconfont icon-rotate"></i>
				<span v-if="rotateTime">停止</span>
				<span v-else>自动</span>
				<!-- <span style="font-size: 0.2rem; transform: scale(0.8)">自动/停止</span> -->
			</div>
		</div>
		<van-popup v-model="setShow" position="bottom" :overlay="false">
			<div class="set-view" :class="setShow ? 'showset' : ''">
				<div class="title-view">
					<span class="title">设置</span>
					<div class="close-text" @click="setShow = false">取消</div>
				</div>
				<!-- <input type="file" /> -->
				<div class="title1">旋转速度</div>
				<div class="center-view">
					<van-stepper v-model="rotationalspeed" theme="round" button-size="28" input-width="50"
						disable-input />
				</div>
				<div class="title1">更换背景</div>
				<div class="center-view">
					<van-uploader v-model="fileList" multiple upload-icon="plus" max-count="1" />
				</div>
				<!-- <div>
            <van-field v-model="indexValue" label="下标" placeholder="请输入下标" />
            <van-field v-model="xValue" label="x" placeholder="请输入x" />
            <van-field v-model="yValue" label="y" placeholder="请输入y" />
            <van-field v-model="zValue" label="z" placeholder="请输入z" />
            <van-button type="primary" @click="setMeshChildren()" >设置</van-button>
        </div> -->
			</div>
		</van-popup>

		<van-popup v-model="showCfslider" position="bottom" :overlay="false">
			<div class="set-view">
				<div class="cfslider">
					<van-slider v-model="cfslider" :max="cflist.length" bar-height="10">
						<template slot="button">
							<div class="custom-button">
								<span v-if="cfslider != 0 && modelDetails[cfslider - 1]">{{
                  modelDetails[cfslider - 1].detailsName
                }}</span>
								<span v-else>{{ cfslider }}</span>
							</div>
						</template>
					</van-slider>
				</div>
			</div>
		</van-popup>

		<van-popup v-model="showContent" position="bottom" :overlay="false">
			<div class="model-content">
				<div class="left" @click="playAudio()">
					<van-icon class="icon" name="volume" />
					<div class="left-tview">
						<span>{{modelData.name}}</span>
						<div></div>
						<span>{{modelData.englishName}}</span>
					</div>
				</div>
				<div class="right">
					<span>{{modelData.details}}</span>
				</div>
			</div>
		</van-popup>

		<div class="off-fullScreen-view" :class="{ show: fullScreen }">
			<button class="off-fullScreen-btn" @click="fullScreen = false">
				退出全屏
			</button>
		</div>

		<div class="share-page" v-if="showShare" @click="showShare = false">
			<div style="text-align: right; padding-right: 1.5rem">
				<img src="@/assets/icon/ic-share.png" style="width: 2rem" />
			</div>
			<div class="share-menu-list">
				<div class="share-menu-item" style="margin-right: 1.4rem">
					<div class="icon-view">
						<img class="icon" src="@/assets/icon/ic-share1.png" />
					</div>
					<div>分享给朋友</div>
				</div>
				<div class="share-menu-item">
					<div class="icon-view">
						<img class="icon" src="@/assets/icon/icon-pyq.png" />
					</div>
					<div>分享到朋友圈</div>
				</div>
			</div>
			<div></div>
		</div>
		<!--  v-if="loading" -->
		<div class="loading-page" v-if="loading">
			<van-circle v-model="loaded" :rate="0" speed="200" :size="200">
				<div class="loading-default" slot="default">
					<div class="progress">{{ loaded }}%</div>
					<div>
						如果长时间未响应请<span style="color: #1989fa" @click="onMounted">刷新</span>
					</div>
				</div>
			</van-circle>
		</div>
		<audio id="audio" :src="audiosrc"></audio>
	</div>
</template>

<script>
	import * as THREE from "three";
	import {
		getModelList,
		cancelCollection,
		collection,
		modelRead,
	} from "@/api/index";

	import {
		ImagePreview
	} from "vant";
	import {
		OrbitControls
	} from "three/examples/jsm/controls/OrbitControls"; // 控制器
	import {
		OBJLoader
	} from "three/examples/jsm/loaders/OBJLoader"; // obj文件加载
	import {
		FBXLoader
	} from "three/examples/jsm/loaders/FBXLoader"; // fbx文件加载
	import {
		GLTFLoader
	} from "three/examples/jsm/loaders/GLTFLoader"; // GLTF文件加载

	import {
		TGALoader
	} from "three/examples/jsm/loaders/TGALoader"; // GLTF文件加载

	// import {
	// 	TextureLoader
	// } from "three/examples/jsm/loaders/TextureLoader"; // GLTF文件加载


	import {
		MTLLoader
	} from "three/examples/jsm/loaders/MTLLoader"; // 材质mtl文件导入
	import {
		EffectComposer
	} from "three/examples/jsm/postprocessing/EffectComposer";
	import {
		FXAAShader
	} from "three/examples/jsm/shaders/FXAAShader";
	import {
		ShaderPass
	} from 'three/examples/jsm/postprocessing/ShaderPass.js'
	import {
		CSS2DObject,
		CSS2DRenderer,
	} from "three/examples/jsm/renderers/CSS2DRenderer";
	import Voice from "./baiduyy";
	import {
		Uploader
	} from "vant";
	let audio;
	var color = "#000000",
		liwidth = 10,
		isdraw = false;
	// let zwfbx = require('@/assets/zwmx/baiji.FBX')
	export default {
		name: "Index",
		components: {
			Uploader,
		},
		data() {
			return {
				scene: "",
				light: "",
				camera: "",
				renderer: "",
				box3: "",
				box3_center: "",
				isdebug: false,
				modelMesh: "",
				rotateTime: "",
				setShow: false,
				fileList: [],
				rotationalspeed: 1,
				fullScreen: false,
				showShare: false,
				showContent: true,
				showcontext: false,
				search: "",
				// showModeDetails:[],
				modelDetails: [],
				dataCurrent: -1,
				loaded: 0,
				loading: true,
				text: "",
				// tgaurl:'/static/中药饮片/甘草/gancao_D.tga',
				// objurl: "/static/mod/congfu/congfu.obj",
				// mtlurl: "/static/mod/congfu/congfu.mtl",
				// tgaurl: "/static/mod/congfu/congfu_D.tga",

				objurl: "/static/mod/shuihulumiao/shuihulumiao.obj",
				mtlurl: "/static/mod/shuihulumiao/shuihulumiao.mtl",

				tgaurl: "/static/mod/shuihulumiao/shuihulumiao_D.tga",
				fbxurl: "/static/mod/shuihulumiao/shuihulumiao.FBX",

				// objurl: "/static/粉红色运输空间场景/5b2f3c072c55d.obj",
				// mtlurl: "/static/粉红色运输空间场景/5b2f3c072c55d.mtl",
				// fbxurl: "/static/zwmx/baiji/baiji.FBX",
				// fbxurl: "@/assets/zwmx/baiji.FBX",
				// tgaurl: "/static/zwmx/baiji/baiji_D.tga",
				gltfurl: "/static/generator/scene.gltf",
				textureurl: "/static/generator/textures/Generator_metallicRoughness.png",
				scale: 0.15,
				// scale: 0.002,
				indexValue: 0,
				xValue: 0,
				yValue: 0,
				zValue: 0,
				modelData: "",
				modelId: "",
				istouch: false,
				touch: {
					pageX: 0,
					pageY: 0,
				},
				cfslider: 0, //拆分程度
				showCfslider: false,
				cflist: [],
				audiosrc: "",
				resetPosition: {
					x: 0,
					y: 0,
					z: 0,
				},
				is_showAll: true,
				newData: "",
				ismouse: false,
				// contentData: '',
				playaudio: null
			};
		},
		computed: {
			backgroundImage() {
				let src = "";
				if (this.fileList.length) {
					src = this.fileList[0].content;
				}
				return src;
			},
			contentData() {
				let data = "";
				if (this.modelDetails.length) {
					data = this.modelDetails[this.dataCurrent];
				}
				return data;
			},
			showModeDetails() {
				let list = [];
				if (this.search) {
					for (let i in this.modelDetails) {
						let item = this.modelDetails[i];
						if (item.detailsName.indexOf(this.search) != -1) {
							list.push(item);
						}
					}
				} else {
					list = this.modelDetails;
				}
				return list;
			},
		},
		watch: {
			istouch(e) {
				if (e) {
					this.off3DMouser();
				} else {
					this.on3DMouser();
				}
			},
			cfslider(n, o) {
				// console.log("cccccc",n,o)
				if (n != 0) {
					let newdata = this.cflist[n - 1];
					newdata && this.cfTranform(newdata, "new");
					this.newData = newdata;
				} else {
					this.newData = "";
				}
				if (o != 0) {
					let olddata = this.cflist[o - 1];
					olddata && this.cfTranform(olddata, "old");
				}
				this.dataCurrent = n ? n - 1 : n;
			},
			fullScreen(e) {
				// 全屏
				if (e) {
					this.showCfslider = false;
					this.showContent = false;
				} else {
					this.showContent = true;
				}
			},
		},
		methods: {
			/**初始化 */
			initScene() {
				this.scene = new THREE.Scene();
				// 0x404040 0xffffff
				const ambientLight = new THREE.AmbientLight(0x666666, 1);
				this.scene.add(ambientLight); //灯光
				if (this.isdebug) {
					// 坐标轴
					var axesHelper = new THREE.AxesHelper(15);
					this.scene.add(axesHelper);
				}
			},
			initCamera() {
				const that = this;
				const aspect = window.innerWidth / innerHeight; //宽高可根据实际项目要求更改 如果是窗口高度改为innerHeight
				this.camera = new THREE.PerspectiveCamera(45, aspect, 1, 112000);
				this.camera.position.set(5, 0, 30);
				this.camera.lookAt(new THREE.Vector3(0, 0, 0)); // 让相机指向原点

				const pointLight = new THREE.PointLight(0x666666, 1, 100);
				pointLight.position.set(0, 0, 120100);
				this.scene.add(pointLight);
				this.scene.add(this.camera);

				// onresize 事件会在窗口被调整大小时发生
				window.onresize = function() {
					// 重置渲染器输出画布canvas尺寸
					that.renderer.setSize(window.innerWidth, window.innerHeight);
					// 重置相机投影的相关参数
					let k = window.innerWidth / window.innerHeight; //窗口宽高比
					that.camera.updateProjectionMatrix();
				};
			},
			initRenderer() {
				this.renderer = new THREE.WebGLRenderer({
					antialias: true,
					alpha: true,
				});

				// this.renderer.physicallyCorrectLights = true;
				this.renderer.setPixelRatio(window.devicePixelRatio * 2);

				this.renderer.toneMappingExposure = 1.0;
				this.renderer.shadowMap.enabled = true;
				this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
				this.renderer.setSize(window.innerWidth, window.innerHeight);
				// this.renderer.outputEncoding = THREE.sRGBEncoding;

				this.container = document.getElementById("academy");
				this.renderer.domElement.setAttribute("id", "canvas");
				this.container.appendChild(this.renderer.domElement);
				this.initMover(); //初始触摸事件

				// var composer = new EffectComposer(this.renderer);
				// var FXAAShaderPass = new ShaderPass(FXAAShader);
				// FXAAShaderPass.uniforms['resolution'].value.set(1 / window.innerWidth , 1 / window.innerHeight);
				// FXAAShaderPass.renderToScreen = true;
				// composer.addPass(FXAAShaderPass);

			},
			// 初始化控制器
			initOrbitControls() {
				let controls = new OrbitControls(this.camera, this.renderer.domElement);
				controls.enableDamping = true;
				controls.enableZoom = true;
				controls.autoRotate = true;
				controls.enableRotate = true;
				controls.autoRotateSpeed = 3;
				controls.enablePan = true;
				controls.enableKeys = true;
				controls.keyPanSpeed = 7;
				controls.keys = {
					LEFT: 37,
					UP: 38,
					RIGHT: 39,
					BOTTOM: 40,
				};
				this.controls = controls;
			},
			animate() {
				this.renderer.render(this.scene, this.camera);
				this.requestId = requestAnimationFrame(this.animate);
			},
			init() {
				this.group = new THREE.Group();
				this.initScene();
				this.initCamera();
				this.initRenderer();
				this.initOrbitControls();
			},
			/**加载模型 */
			loadPlant() {
				let that = this;
				let objLoader = new OBJLoader();
				let mtlLoader = new MTLLoader();
				mtlLoader.load(that.mtlurl, function(materials) {
					materials.preload();
					objLoader.setMaterials(materials);
					objLoader.load(
						that.objurl,
						function(obj) {
							that.modelMesh = obj;
							console.log("obj:", obj, materials);
							that.modelMesh.position.set(0, -3, 0);
							that.modelMesh.scale.set(that.scale, that.scale, that.scale);

							that.scene.add(that.modelMesh);
							const tgaloader = new TGALoader();
							tgaloader.load(that.tgaurl, (texture) => {
								//模型使用新的贴图纹理
								console.log("texture:", texture);
								texture.needsUpdate = true;
								var material = new THREE.MeshBasicMaterial({
									map: texture,
									transparent: true,
									side: THREE.DoubleSide,
									depthWrite: true
								});
								that.modelMesh.traverse(function(child) {
									console.log("child:", child)
									if (child.isMesh) {

										child.material = material
										// child.frustumCulled = false;
										// // child.material.map = texture;
										// child.material.needsUpdate = true;
										// child.material.side = THREE.DoubleSide;
										// // child.material.opacity = 0.9;

										//  child.material.emissive =  child.material.color;
										// child.material.emissiveMap = child.material.map
										// 	child.material.depthTest = true;
										// 	child.material.depthWrite =true;
										// 	 child.material.transparent = true;
										// 	child.material.map = texture;
									}
								});

								console.log("that.modelMesh:", that.modelMesh);
								that.renderer.outputEncodimg = THREE.sRGBEncoding;
								that.renderer.render(that.scene, that.camera);
							});
						},
						function(xhr) {
							console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
							that.loaded = (xhr.loaded / xhr.total).toFixed(2) * 100;
							setTimeout(function() {
								that.loading = false;
							}, 500);
						},
						function(error) {
							console.error("An error happened", error);
						}
					);
				});
			},
			loadPlantFbx() {
				let that = this;
				var fbxLoader = new FBXLoader();
				var material = new THREE.MeshPhongMaterial({
					side: THREE.DoubleSide,
					shininess: 1,
				});
				// fbxLoader.setMaterials(material)
				console.log("that.fbxurl:", that.fbxurl)
				fbxLoader.load(
					that.fbxurl,
					function(fbx) {
						that.modelMesh = fbx;
						// that.modelMesh.position.set(0, 105, 0);
						// that.modelMesh.scale.set(0.03, 0.03, 0.03);
						that.modelMesh.position.set(0, -3, 0);
						that.modelMesh.scale.set(that.scale, that.scale, that.scale);
						that.scene.add(that.modelMesh);
						console.log("fbx:", that.modelMesh);
						if (that.tgaurl) {
							const tgaloader = new TGALoader();
							let cflist = [];
							tgaloader.load(
								that.tgaurl,
								(texture) => {
									// texture.encoding = THREE.sRGBEncoding;
									that.modelMesh.traverse((child) => {
										// console.log("child:", child);
										if (child.isMesh) {
											child.material.map.encoding = THREE.sRGBEncoding;
											texture.needsUpdate = true;
											child.material = material;
											// child.material.opacity = 0.9;
											child.material.depthTest = true;
											child.material.depthWrite = true;
											child.material.transparent = true;
											child.material.map = texture;
											child.material.alphaTest = 0.5;
											// console.log("name:", child.name);

											cflist.push({
												name: child.name,
												position: child.position,
											});
										}
									});
									that.cflist = cflist;
									that.setModelPosition(that.modelMesh);
									that.renderOrStop();
									// console.log("that.cflist:", that.cflist);
									setTimeout(function() {
										that.loading = false;
									}, 500);
								},
								(xhr) => {
									that.loaded =
										parseInt(((xhr.loaded / xhr.total) * 100) / 2) + 50;
									// console.log(that.loaded, "% loaded tga");
								},
								(error) => {
									console.error("An error happened tga", error);
								}
							);
						}
					},
					function(xhr) {
						that.loaded = parseInt(((xhr.loaded / xhr.total) * 100) / 2);
						// console.log(that.loaded, "% loaded");
					},
					function(error) {
						console.error("An error happened", error);
					}
				);
			},
			loadPlantGltf() {
				let that = this;
				var gltfLoader = new GLTFLoader();
				let textureLoader = new THREE.TextureLoader();
				var textureNormal = textureLoader.load(that.textureurl);
				var material = new THREE.MeshPhongMaterial({
					side: THREE.DoubleSide,
					shininess: 1,
				});
				// fbxLoader.setMaterials(material)
				gltfLoader.load(
					that.gltfurl,
					function(gltf) {
						that.modelMesh = gltf;
						that.modelMesh.scene.position.set(0, 0, 0);
						that.modelMesh.scene.scale.set(0.05, 0.05, 0.05);
						// that.modelMesh.position.set(0, -3, 0);
						// that.modelMesh.scale.set(that.scale, that.scale, that.scale);
						console.log(gltf)
						that.scene.add(gltf.scene);
						setTimeout(function() {
							that.loading = false;
						}, 500);
						console.log("fbx:", that.modelMesh);

						that.modelMesh.scene.traverse(function(gltf) {
							if (gltf.type === 'Mesh') {
								gltf.material = new THREE.MeshPhongMaterial({
									color: 0xcccccc,
									map: textureNormal,
									normalScale: new THREE.Vector2(3, 3),
								})
							}
						})

						// if (that.tgaurl) {
						// 	const tgaloader = new TGALoader();
						// 	let cflist = [];
						// 	tgaloader.load(
						// 		that.tgaurl,
						// 		(texture) => {
						// 			// texture.encoding = THREE.sRGBEncoding;
						// 			that.modelMesh.traverse((child) => {
						// 				// console.log("child:", child);
						// 				if (child.isMesh) {
						// 					// child.material.map.encoding = THREE.sRGBEncoding;
						// 					//此处更新fbx 模型的贴图信息 ，需要在引入GTALoader.js
						// 					//模型使用新的贴图纹理
						// 					texture.needsUpdate = true;
						// 					child.material = material;
						// 					// child.material.opacity = 0.9;
						// 					child.material.depthTest = true;
						// 					child.material.depthWrite =true;
						// 					 child.material.transparent = true;
						// 					child.material.map = texture;
						// 					// console.log("name:", child.name);
						// 					cflist.push({
						// 						name: child.name,
						// 						position: child.position,
						// 					});
						// 				}
						// 			});
						// 			that.cflist = cflist;
						// 			that.setModelPosition(that.modelMesh);
						// 			that.renderOrStop();
						// 			// console.log("that.cflist:", that.cflist);
						// 			setTimeout(function() {
						// 				that.loading = false;
						// 			}, 500);
						// 		},
						// 		(xhr) => {
						// 			that.loaded =
						// 				parseInt(((xhr.loaded / xhr.total) * 100) / 2) + 50;
						// 			// console.log(that.loaded, "% loaded tga");
						// 		},
						// 		(error) => {
						// 			console.error("An error happened tga", error);
						// 		}
						// 	);
						// }
					},
					function(xhr) {
						that.loaded = parseInt(((xhr.loaded / xhr.total) * 100) / 1);
						// console.log(that.loaded, "% loaded");
					},
					function(error) {
						console.error("An error happened", error);
					}
				);
			},

			setModelPosition(object) {
				object.updateMatrixWorld();
				// 获得包围盒得min和max
				const box = new THREE.Box3().setFromObject(object);
				// 返回包围盒的宽度，高度，和深度
				const boxSize = box.getSize(new THREE.Vector3());
				// 返回包围盒的中心点
				console.log("boxSize:", boxSize);
				const center = box.getCenter(new THREE.Vector3());
				// object.position.x += object.position.x - center.x;
				object.position.y += object.position.y - center.y * 0.8;
				// object.position.z += object.position.z - center.z;
				this.resetPosition.x = object.position.x;
				this.resetPosition.y = object.position.y;
				this.resetPosition.z = object.position.z;
				this.xValue = this.resetPosition.x;
				this.yValue = this.resetPosition.y;
				this.zValue = this.resetPosition.z;
			},
			renderOrStop() {
				if (this.rotateTime) {
					clearInterval(this.rotateTime);
					this.rotateTime = "";
				} else {
					this.render();
				}
			},
			render() {
				//执行渲染操作   指定场景、相机作为参数
				let that = this;
				this.renderer.render(this.scene, this.camera);
				if (this.rotateTime) {
					clearInterval(this.rotateTime);
				}
				this.rotateTime = setInterval(function() {
					that.modelMesh.rotateY(that.rotationalspeed / 100); //y轴旋转
					// that.modelMesh.rotateX(0.01); //x轴旋转
				}, 16);
				//   requestAnimationFrame(this.renderer); //请求再次执行渲染函数render
			},
			initMover() {},
			moveMesh() {
				that.modelMesh.x += 0.01;
				if (that.modelMesh.x > 5) {
					that.modelMesh.x = 0;
				}
				this.renderer.render(this.scene, this.camera);
			},
			ckickMove() {
				this.off3DMouser();
			},
			showSet() {
				this.setShow = true;
			},
			on3DMouser() {
				//开启触摸控制
				this.controls.enableZoom = true;
				this.controls.enableRotate = true;
				this.controls.enablePan = true;
			},
			off3DMouser() {
				//关闭触摸控制
				this.controls.enableZoom = false;
				this.controls.enableRotate = false;
				this.controls.enablePan = false;
			},
			setMeshChildren() {
				let that = this;
				that.modelMesh.children[this.indexValue].position.set(
					this.xValue,
					this.yValue,
					this.zValue
				);
			},
			init2d() {
				// 获取页面元素this.renderer.domElement
				var canvas = document.getElementById("canvas2d");
				//   let style = this.renderer.domElement.getAttribute("style");
				let height = window.innerHeight;
				let width = window.innerWidth;
				canvas.setAttribute("style", `width:${width}px;height:${height}px`);
				var can = canvas.getContext("2d");
				console.log(can);
				// var color = document.getElementById("color");
				// var bgcolor = document.getElementById("bgcolor");
				// var liwidth = document.getElementById("linewidth");
				// var clear = document.getElementById("clear");
				// 鼠标按下
				canvas.onmousedown = function(event) {
					console.log("cccc");
					isdraw = true;
					// 设置线条颜色
					can.strokeStyle = color;
					// 设置线条粗细
					can.lineWidth = liwidth;
					can.beginPath();
					// 将画笔移动到鼠标所在位置
					can.moveTo(event.offsetX, event.offsetY);
				};
				// 鼠标移动
				canvas.onmousemove = function(event) {
					// 判断鼠标是否在按下状态
					console.log("cccc", isdraw);
					if (isdraw) {}
					// 设置线条终点
					can.lineTo(event.offsetX, event.offsetY);
					// 画线条
					can.stroke();
				};
				// 松开鼠标
				canvas.onmouseup = function() {
					isdraw = false;
				};
				// 保证鼠标未松开时回到画布能继续操作
				// 鼠标移出画布
				canvas.onmouseout = function() {
					// 鼠标仍然在按下状态
					if (isdraw == true) {
						// 当鼠标移动到画布上面
						canvas.onmouseover = function(event) {
							// 将画笔移动到鼠标进入的位置
							can.moveTo(event.offsetX, event.offsetY);
						};
					}
				};
				// // 清除画布
				// clear.onclick = function(){
				//     can.clearRect(0,0,canvas.width,canvas.height)
				// }
				// // 设置画布背景
				// bgcolor.onchange = function(){
				//     canvas.style.backgroundColor = bgcolor.value
				// }
			},
			getlist() {
				let that = this;
				getModelList({
					name: "",
					pageNum: 1,
					pageSize: 10,
					userId: this.$store.getters["user/userId"],
				}).then((res) => {
					that.modelData = res.rows[0];
					console.log("that.modelData", that.modelData);
					that.tgaurl = that.modelData.tgaUrl;
					that.fbxurl = that.modelData.fxbUrl;
					// that.fbxurl ='/static/miaowa/BR_Bulbasaur-Shiny01.fbx';
					this.loadPlant();
					// this.loadPlantFbx();
				});
			},
			showimage() {
				ImagePreview({
					images: [this.modelData.imgUrl],
					closeable: true
				});
			},
			getUserInfo() {
				this.$store.dispatch("user/getUserInfo").then((res) => {});
			},
			async clickCollection() {
				let that = this,
					requestData;
				if (that.modelData.collectionState == "1") {
					requestData = await cancelCollection({
						modelId: that.modelData.id,
						userId: this.$store.getters["user/userId"],
					});
					that.modelData.collectionState = "0";
				} else {
					requestData = await collection({
						modelId: that.modelData.id,
						userId: this.$store.getters["user/userId"],
					});
					that.modelData.collectionState = "1";
				}
			},
			async getModel() {
				// 请求模型数据
				const that = this;
				try {
					let res = await modelRead({
						modelId: this.modelId,
						userId: this.$store.getters["user/userId"],
					});
					that.modelData = res.data;
					console.log("that.modelData", that.modelData);
					// 模型文件 ----当前后台无数据
					that.tgaurl = that.modelData.tgaUrl;
					that.fbxurl = that.modelData.fxbUrl;

					let modelDetails = [];
					try {
						res.data.detailsList.forEach((item, index) => {
							modelDetails.push({
								...item,
								index,
							});
						});
						that.modelDetails = modelDetails;
					} catch (error) {}
					// 两种加载方式
					// this.loadPlant();
					this.loadPlantFbx();
				} catch (error) {
					let detailsList = [{
						detailsName: '部位1',
						detailsEnglishName: 'part',
						detailsContent: '部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1部位1'
					}]
					let modelDetails = [];
					try {
						detailsList.forEach((item, index) => {
							modelDetails.push({
								...item,
								index,
							});
						});
						that.modelDetails = modelDetails;
					} catch (error) {}
					console.error(error);
					this.loadPlantFbx();
					// this.loadPlant();
					// this.loadPlantGltf()
				}
			},
			touchstart(e) {
				let touch = e.touches[0];
				this.touch["pageX"] = touch.pageX;
				this.touch["pageY"] = touch.pageY;
			},
			touchmove(e) {
				if (this.istouch) {
					let touch = e.touches[0];
					// console.log(touch["pageX"], touch["pageY"]);
					let x = this.touch["pageX"] - touch["pageX"];
					let y = this.touch["pageY"] - touch["pageY"];
					// console.log(x, y);
					this.xValue -= x / 100;
					this.yValue += y / 100;
					this.modelMesh.position.set(this.xValue, this.yValue, this.zValue);
					this.renderer.render(this.scene, this.camera);
					this.touch["pageX"] = touch.pageX;
					this.touch["pageY"] = touch.pageY;
				}
			},
			touchend(e) {
				let touch = e.touches[0];

			},
			mousedown(e) {
				console.log(e)
				this.ismouse = true;
				this.touch["pageX"] = e.pageX;
				this.touch["pageY"] = e.pageY;
			},
			mousemove(e) {
				console.log(this.istouch, this.ismouse)
				if (this.istouch && this.ismouse) {
					let touch = e;
					// console.log(touch["pageX"], touch["pageY"]);
					let x = this.touch["pageX"] - touch["pageX"];
					let y = this.touch["pageY"] - touch["pageY"];
					// console.log(x, y);
					this.xValue -= x / 100;
					this.yValue += y / 100;
					this.modelMesh.position.set(this.xValue, this.yValue, this.zValue);
					this.renderer.render(this.scene, this.camera);
					this.touch["pageX"] = touch.pageX;
					this.touch["pageY"] = touch.pageY;
				}
			},
			mouseup(e) {
				this.ismouse = false;
			},
			reset() {
				//重置
				this.xValue = this.resetPosition.x;
				this.yValue = this.resetPosition.y;
				this.zValue = this.resetPosition.z;
				// this.modelMesh.x = this.resetPosition.x;
				// this.modelMesh.y = this.resetPosition.y;
				// this.modelMesh.z = this.resetPosition.z;
				this.camera.position.set(5, 0, 30);
				this.cfslider = 0;
				this.modelMesh.position.set(this.xValue, this.yValue, this.zValue);
				this.camera.lookAt(new THREE.Vector3(0, 0, 0)); // 让相机指向原点
				this.renderer.render(this.scene, this.camera);
				if (!this.is_showAll) {
					this.showOrhidden();
				}
			},
			cfTranform(data, type) {
				const that = this;
				that.modelMesh.traverse((child) => {
					if (child.isMesh) {
						//此处更新fbx 模型的贴图信息 ，需要在引入GTALoader.js
						//模型使用新的贴图纹理
						console.log(child, data);
						if (data && child.name == data.name) {
							console.log("child:", child.position.x);
							if (type == "new") {
								child.position.set(
									child.position.x + 6,
									child.position.y,
									child.position.z
								);
							} else {
								child.position.set(
									child.position.x - 6,
									child.position.y,
									child.position.z
								);
							}
							this.renderer.render(this.scene, this.camera);
						}
					}
				});
			},
			playAudio() {
				if (this.playaudio != null) {
					this.playaudio.pause();
					this.playaudio = null;
				}
				let that = this;
				this.playaudio = new Audio(that.modelData.detailsAudio);
				this.playaudio.play();
				// let text =
				// 	`${this.contentData.detailsName},${this.contentData.detailsEnglishName},${this.contentData.detailsContent}`;
				// Voice({
				// 	voiceSet: {
				// 		tex: text,
				// 		per: 1,
				// 	},
				// 	audioSet: {
				// 		volume: 1,
				// 	},
				// 	lineUp: true, // 加入语音队列
				// 	returnAudio: true, // 返回音频对象
				// }).then((res) => {
				// 	console.log(res);
				// 	that.audiosrc = res;
				// 	that.$nextTick(function() {
				// 		console.log(audio);
				// 		audio.play();
				// 	});
				// });
			},
			clickModeDetail(index) {
				this.dataCurrent = index;
				this.cfslider = index + 1;
			},
			onMounted() {
				if (window.location.href.indexOf("#reloaded") == -1) {
					window.location.href = window.location.href + "#reloaded";
					window.location.reload();
				}
			},
			clickShowCfslider() {
				this.showCfslider = !this.showCfslider;
				this.showContent = !this.showCfslider;
			},
			showOrhidden() {
				if (this.is_showAll && this.newData) {
					this.modelMesh.traverse((child) => {
						if (child.isMesh) {
							this.renderer.render(this.scene, this.camera);
							if (child.name == this.newData.name) {
								console.log(child.name, this.newData.name);
								child.visible = true;
							} else child.visible = false;
							this.renderer.render(this.scene, this.camera);
						}
					});
					this.is_showAll = false;
				} else if (!this.is_showAll) {
					this.modelMesh.traverse((child) => {
						if (child.isMesh) {
							child.visible = true;
							this.renderer.render(this.scene, this.camera);
						}
					});
					this.is_showAll = true;
				}
			},
		},
		mounted() {
			this.modelId = this.$route.query.modelId;
			let userId = this.$route.query.userId;
			let token = this.$route.query.token;
			console.log(this.modelId, userId);
			this.$store.commit("user/setUserId", userId);
			this.$store.commit("user/setAccessToken", token);
			this.getModel();
			// this.init2d();
			// this.getUserInfo();
			this.init();
			// this.getlist();
			// this.loadPlant();
			// this.loadPlantFbx();
			this.animate();

			document.getElementsByTagName("canvas")[0].style.verticalAlign = "bottom"; //解决canvas底部留白问题
			audio = document.getElementById("audio");
			// window.addEventListener("click", this.clickModel, false);
			// window.addEventListener("resize", this.onResize, false);
		},
	};
</script>

<style>
	body {
		background: #f6f6f6;
	}

	.page {
		font-size: 0.3rem;
	}

	* {
		transition: all 0.2s;
	}

	.iconfont {
		font-size: 0.4rem;
	}

	#academy {
		width: 100%;
		height: 100vh;
		background: #f6f6f6;
		background-size: cover;
		background-position: center center;
	}

	#canvas2d {
		width: 100%;
		height: 100vh;
		position: absolute;
		let: 0;
		bottom: -100%;
	}

	.menu-view {
		position: fixed;
		top: 0px;
		font-size: 0.24rem;
		max-height: 100vh;
		overflow-y: scroll;
		padding: 10px;
	}

	.right-menu-view {
		right: 0px;
		top: 0px;
		padding: 10px;
	}

	.left-menu-view {
		left: 0px;
		padding-top: 0.4rem;
		width: auto;
		overflow-y: initial;
	}

	.fullScreen.right-menu-view {
		right: -100%;
	}

	.fullScreen.left-menu-view {
		left: -100%;
	}

	.menu-item {
		width: 1rem;
		height: 1rem;
		background: #fff;
		border-radius: 100px;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
		margin-bottom: 15px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 0.25rem;
		cursor: pointer;
	}

	.menu-item .icon {
		width: 0.4rem;
		height: 0.4rem;
	}

	.menu-item.action {
		background: #4c7bf1;
		color: #fff;
	}

	.set-view {
		/* // position: fixed;
        // bottom: -100%; */
		background: #ffff;
		width: 100%;
		position: relative;
	}

	.set-view .title-view {
		line-height: 1rem;
		text-align: center;
	}

	.set-view .close-text {
		position: absolute;
		right: 10px;
		top: 0px;
		font-size: 0.28rem;
		color: #a9a9a9;
	}

	.set-view .title {
		font-weight: bold;
	}

	.set-view .title1 {
		font-weight: bold;
		padding: 0.1rem;
		font-size: 0.34rem;
	}

	.set-view .center-view {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.set-view .van-stepper--round button {
		background: #fff !important;
		color: #000;
		border: 1px solid #a9a9a9;
	}

	.set-view .van-uploader__upload {
		background: #fff;
		border: 1px solid #000000;
		border-radius: 10px;
	}

	.set-view .van-image__img {
		border-radius: 10px;
	}

	.set-view .van-uploader__upload-icon {
		color: #000000;
	}

	.set-view .van-popup--bottom {
		border-radius: 10px 10px 0px 0px;
	}

	.menu-ces {
		width: 2rem;
		background: #fff;
		border-radius: 0px 10px 10px 0px;
		font-size: 0.28rem;
		padding: 0.2rem;
		margin-left: -10px;
		margin-bottom: 0.3rem;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
	}

	.menu-ces .search-view {
		display: flex;
		background: #eeee;
		border-radius: 0.4rem;
		overflow: hidden;
		align-items: center;
		padding: 0px 5px;
		line-height: 0.5rem;
	}

	.menu-ces .search-view input {
		width: 0.6rem;
		flex: 1;
		border: none;
		height: 0.5rem;
		background: #eeee;
		text-align: center;
	}

	.menu-ces .data-view {
		text-align: center;
		margin-top: 10px;
		line-height: 0.7rem;
		font-size: 0.3rem;
		max-height: 4rem;
		overflow-y: scroll;
	}

	.menu-ces .data-item {
		border-radius: 100px;
		cursor: pointer;
	}

	.detailAction {
		background-color: #4c7bf1;
		color: #fff;
	}

	.off-fullScreen-view {
		position: fixed;
		width: 100%;
		bottom: -100%;
		text-align: center;
	}

	.off-fullScreen-btn {
		background: #fff;
		border-radius: 10px;
		font-size: 0.32rem;
		line-height: 0.8rem;
		border: none;
		padding: 0rem 0.5rem;
	}

	.off-fullScreen-view.show {
		bottom: 0.2rem;
	}

	.showset {
		bottom: 0;
	}

	.cfslider {
		padding: 0.5rem 0.5rem 0px;
		height: 0.5rem;
	}

	.cfslider .custom-button {
		width: 26px;
		color: #fff;
		font-size: 10px;
		line-height: 18px;
		text-align: center;
		background-color: #4c7bf1;
		border-radius: 100px;
	}

	.share-page {
		position: fixed;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		top: 0px;
		left: 0px;
	}

	.share-page .share-menu-list {
		display: flex;
		justify-content: center;
	}

	.share-page .share-menu-list .share-menu-item {
		color: #909090;
		font-size: 0.3rem;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.share-page .share-menu-list .icon-view {
		width: 1rem;
		height: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #091c09;
		border-radius: 10px;
		margin-bottom: 10px;
	}

	.share-page .share-menu-list .icon-view .icon {
		width: 0.7rem;
		height: 0.7rem;
	}

	.text-cut {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.text-cut3 {
		display: -webkit-box;
		/* autoprefixer: off */
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		/* autoprefixer: on */
		overflow: hidden;
	}

	.model-content {
		display: flex;
		padding: 0.1rem;
	}

	.model-content .left {
		display: flex;
		font-size: 0.32rem;
		font-weight: bold;
	}

	.model-content .left .icon {
		margin-top: 0.1rem;
	}

	.model-content .left .left-tview {
		margin-left: 10px;
	}

	.model-content .right {
		flex: 1;
		color: #a2a2a4;
		font-size: 0.28rem;
		margin-left: 10px;
		margin-right: 10px;
		line-height: 0.4rem;
		overflow-y: scroll;
		max-height: 60vh;
	}

	.model-content .more {
		display: flex;
		align-items: end;
		color: #436be5;
	}

	.model-content .text-cut3 {
		/* // max-height: 1.2rem; */
		overflow: hidden;
		/*超出隐藏*/
		text-overflow: ellipsis;
		/*文本溢出时显示省略标记*/
		display: -webkit-box;
		/*设置弹性盒模型*/
		-webkit-line-clamp: 3;
		/*文本占的行数,如果要设置2行加...则设置为2*/
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/*! autoprefixer: on */
	}

	.loading-page {
		position: fixed;
		top: 0;
		background-color: #000;
		width: 100%;
		height: 100%;
		z-index: 9999;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
	}

	.loading-page .loading-default {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 0.28rem;
	}

	.loading-page .progress {
		font-size: 0.7rem;
		font-weight: bold;
	}

	::-webkit-scrollbar {
		display: none;
	}

	@media screen and (min-width: 550px) {
		.page {
			font-size: 18px;
		}

		.menu-view {
			font-size: 14px;
			padding: 10px;
		}

		.menu-item {
			width: 60px;
			height: 60px;
			border-radius: 100px;
			margin-bottom: 15px;
			font-size: 14px;
		}

		.iconfont {
			font-size: 22px;
		}

		.menu-item .icon {
			width: 22px;
			height: 22px;
		}

		.menu-ces {
			width: 200px;
			background: #fff;
			border-radius: 0px 10px 10px 0px;
			font-size: 18px;
			padding: 10px;
			margin-left: -10px;
			margin-bottom: 30px;
			box-shadow: 0px 0px 10px rgb(0 0 0 / 30%);
		}

		.menu-ces .search-view {
			padding: 0px 5px;
			line-height: 40px;
			margin-bottom: 10px;
		}

		.menu-ces .search-view input {
			flex: 1;
			border: none;
			height: 40px;
			background: #eeee;
			text-align: center;
		}

		.menu-ces .data-view {
			text-align: center;
			line-height: 30px;
			font-size: 16px;
			max-height: 400px;
			overflow-y: scroll;
			padding-top: 1px;
		}

		.set-view .title-view {
			line-height: 50px;
		}

		.set-view .close-text {
			right: 10px;
			font-size: 16px;
		}

		.set-view .title1 {
			padding: 10px;
			font-size: 16px;
		}

		.share-menu {
			display: none;
		}

		.off-fullScreen-btn {
			background: #fff;
			border-radius: 5px;
			font-size: 18px;
			line-height: 40px;
			border: none;
			padding: 0px 30px;
		}

		.off-fullScreen-view.show {
			bottom: 0.2rem;
		}

		.cfslider {
			padding: 20px 20px 0px;
			height: 40px;
		}

		.model-content .left {
			font-size: 18px;
		}

		.model-content .right {
			font-size: 16px;
			margin-left: 10px;
			margin-right: 10px;
			line-height: 30px;
			overflow-y: scroll;
			max-height: 40vh;
		}

		.loading-page .progress {
			font-size: 36px;
		}

		.loading-page .loading-default {
			font-size: 16px;
		}
	}
</style>